import { Banner, BlockStack, InlineGrid, Page, Spinner, Text } from '@shopify/polaris'
import { useBccData }           from './useBccData'
import { ExecutiveStrip }       from './ExecutiveStrip'
import { BusinessHealth }       from './BusinessHealth'
import { MoneyPipeline }        from './MoneyPipeline'
import { FinancialPanel }       from './FinancialPanel'
import { OperationalFunnel }    from './OperationalFunnel'
import { ForecastSection }      from './ForecastSection'
import { DepartmentScoreboard } from './DepartmentScoreboard'
import { BusinessMomentum }     from './BusinessMomentum'
import { TodayDecisions }       from './TodayDecisions'
import { RegionalIntelligence } from './RegionalIntelligence'
import { SettlementBridge }     from './SettlementBridge'
import { OrderTypeTable }       from './OrderTypeTable'
import { MarketingEfficiency }  from './MarketingEfficiency'

export function BccPage() {
  const state = useBccData()

  if (state.status === 'loading') {
    return (
      <Page>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '80px 0' }}>
          <Spinner size="large" />
        </div>
      </Page>
    )
  }

  if (state.status === 'error') {
    return (
      <Page>
        <Banner tone="critical" title="Failed to load dashboard">
          <Text as="p" variant="bodyMd">{state.message}</Text>
        </Banner>
      </Page>
    )
  }

  const { data } = state
  const monthLabel = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })

  return (
    <Page title="Business Control Center" subtitle={monthLabel}>
      <BlockStack gap="600">

        {/* 1 — Executive Strip */}
        <ExecutiveStrip data={data} />

        {/* 2 — Business Health */}
        <BusinessHealth data={data} />

        {/* 3 — Today's Decisions */}
        <TodayDecisions data={data} />

        {/* 4 + 5 — Money Pipeline & Financial Panel */}
        <InlineGrid columns="[60%_1fr]" gap="400">
          <MoneyPipeline  data={data} />
          <FinancialPanel data={data} />
        </InlineGrid>

        {/* Cash lens: splits this month's arrivals by the period that earned
            them, so a backlog clearing is not mistaken for a strong month. */}
        <SettlementBridge data={data} />

        {/* Whether spending more is still profitable at the current margin. */}
        <MarketingEfficiency data={data} />

        {/* Per-type success, failure and the cost of each — the split the
            single blended delivery rate was hiding. */}
        <OrderTypeTable data={data} />

        {/* 5 + 6 — Operational Funnel & Forecast */}
        <InlineGrid columns={2} gap="400">
          <OperationalFunnel data={data} />
          <ForecastSection   data={data} />
        </InlineGrid>

        {/* 8 + 10 — Department Scoreboard & Business Momentum */}
        <InlineGrid columns="[60%_1fr]" gap="400">
          <DepartmentScoreboard data={data} />
          <BusinessMomentum     data={data} />
        </InlineGrid>

        {/* 9 — Regional Intelligence */}
        <RegionalIntelligence data={data} />

      </BlockStack>
    </Page>
  )
}
